import React from "react";
import { Drawer, Button } from "antd";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import { UTILS } from "utils";
// import { CatelougeContext } from "store/contexts/Catelouge";
// import { ACTIONS } from "config";

const NavBar = ({ menu, visible, setVisible }) => {
  // const { dispatch } = useContext(CatelougeContext);
  const drawerAction = () => {
    // dispatch({ type: ACTIONS.STORES_CHANGED });
    setVisible(false);
  };
  const dir = UTILS.getLanguageInformation()?.direction;
  const setDrawer = dir === "rtl" ? "right" : "left";
  return (
    <nav className="navbar" style={{ borderBottom: "none", padding: 0 }}>
      <Button
        className="menu"
        type="primary"
        icon={<MenuOutlined />}
        onClick={() => setVisible(true)}
      />
      <Drawer 
        title={
        <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <a href="/">
            <img
              src={process.env.PUBLIC_URL + process.env.REACT_APP_COMPANY_LOGO}
              className="logo"
              style={{margin:0}}
              alt="logo"
            />
          </a>
          <h1 className="font-montserrat m-0 overflow-hidden uppercase" style={{ fontSize: "28px", fontWeight:"900" }}>
            {process.env.REACT_APP_COMPANY_NAME}
          </h1>
        </div>
        <button className="hover:text-blue-500 hover:font-bold" onClick={() => drawerAction()}>
          <CloseOutlined />
        </button>
        </div>}
        placement={setDrawer}
        onClick={drawerAction}
        onClose={drawerAction}
        closable={false}
        open={visible}
        bodyStyle={{
          padding:"10px"
        }}
      >
        {menu}
      </Drawer>
      <a href="/">
        <img
          src={process.env.PUBLIC_URL + process.env.REACT_APP_COMPANY_LOGO}
          className="logo"
          alt="logo"
        />
      </a>
    </nav>
  );
};
export default NavBar;
